export enum TwoFactorAuthScreen {
  'Verify',
  'Trouble',
  'Calling',
  'Locked',
  'Contact',
}
